import { useState as a, useEffect as h } from "react";
const l = (e = !1) => {
  const [o, n] = a(() => typeof window > "u" || e ? "" : window.location.hash || ""), r = (t) => {
    if (typeof window > "u") {
      console.warn("setHashHandler called in a non-browser environment. Hash will not be set.");
      return;
    }
    if (t === "" || t === "#") {
      const i = window.location.pathname + window.location.search;
      history.replaceState(null, "", i), n("");
      return;
    }
    const s = t.startsWith("#") ? t : `#${t}`;
    history.replaceState(null, "", s), n(s);
  };
  return h(() => {
    e && n(window.location.hash);
  }, []), [o, r];
};
export {
  l as useHash
};
